package com.jingfangpai.diagnosisSetting.model

import com.jingfangpai.common.orm.mapping.SignSymptomSettingTriggeredWorsenedBy
import com.jingfangpai.common.orm.mapping.enums.SignSymptomAssociatedFactorName
import kotlinx.serialization.Serializable

@Serializable
class SignSymptomSettingTriggeredWorsenedByDto : SignSymptomSettingTriggeredWorsenedBy(){
    var associatedFactorName: SignSymptomAssociatedFactorName? = null
    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other == null || this::class != other::class) return false
        if (!super.equals(other)) return false

        other as SignSymptomSettingTriggeredWorsenedByDto

        if (associatedFactorName != other.associatedFactorName) return false

        return true
    }

    override fun hashCode(): Int {
        var result = super.hashCode()
        result = 31 * result + (associatedFactorName?.hashCode() ?: 0)
        return result
    }

}